import React from 'react';
import {Grid} from '@material-ui/core';
import './Dashboard.sass';

type DashboardCardErrorProps = {
  title: string;
  iconName: string;
  id: string;
};

const DashboardCardError = (props: DashboardCardErrorProps) => {
  const {title, iconName, id} = props;

  return (
    <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
      <div className="enrollment-dashboard__enrollment-file-card">
        <div className="enrollment-file-card">
          <div className="enrollment-file-card__title-container">
            <Grid container justify="space-between">
              <Grid item md={10} xs={9}>
                <div className="title-container--item">
                  <h3 id={`enrollment-file-card-title-${id}`} className="title-container--item-title">
                    {title}
                  </h3>
                </div>
              </Grid>
              <Grid item container md={2} xs={3} justify="flex-end">
                <div className={`title-container--item__icon-container ${iconName}`}>
                  <i className={`enrollment-file-card__icon icon--${iconName}`}></i>
                </div>
              </Grid>
            </Grid>
          </div>
          <div className="enrollment-file-card__statistics-container">
            <div className="statistics-container--item errors">
              <h4 className="statistics-container--item-title">Error</h4>
              <p className="statistics-container--item-value">Unable to load required data.</p>
            </div>
          </div>
        </div>
      </div>
    </Grid>
  );
};

export default DashboardCardError;
